import { useCallback, useMemo } from "react";
import { useDispatch } from "react-redux";
import { toggleEventPreviewMode } from "../../../../../../store/actions/admin/create-event";
import { useTypedSelector } from "../../../../../../store/reducers/use-typed-selector";
import ModalComponent from "../../../../../general-ui/modal/modal";
import Session from "../../../../../live-event/session/session";
import classNames from 'classnames';
import '../../../../../live-event/session/session.scss';
import './event-preview.scss';
import LiveEventDocumentHead from "../../../../../live-event/live-event-document-head";
import { useParams } from "react-router";
import { ParamsProps } from "../../../../../live-event/live-event";

interface SessionPreviewProps {
	open: boolean;
	singleSession?: boolean;
}

const SessionPreviewModal: React.FC<SessionPreviewProps> = ({ open, singleSession }) => {

	const {
		workingSession,
		workingEvent,
		editorSize
	} = useTypedSelector(state => ({
		workingSession: state.CreateSessionReducer.workingSession,
		workingEvent: state.CreateEventReducer.workingEvent,
		editorSize: state.CreateEventReducer.editorSize
	}));

	const { language } = useParams() as ParamsProps;
	const dispatch = useDispatch();

	const closeModal = useCallback(() => {
		dispatch(toggleEventPreviewMode(null));
	}, [dispatch]);

	const previewSession = useMemo(() => {
		if (singleSession && workingEvent?.sessions[0]) {
			return workingEvent?.sessions[0];
		} else {
			return workingSession ?? undefined;
		}
	}, [singleSession, workingEvent, workingSession]);

	const modalBody = useMemo(() => {
		return workingEvent && (workingSession || workingEvent.sessions[0]) && (
			<div className={classNames('session-preview-wrapper live-event-container', editorSize)}>
				<LiveEventDocumentHead eventBundle={workingEvent} />
				<Session previewBundle={workingEvent!} previewSession={previewSession} previewLanguage={language} />
			</div>
		);
	}, [workingSession, workingEvent, editorSize, previewSession, language]);

	return (
		<div className="preview-modal">
			<ModalComponent
				open={open}
				onRequestClose={closeModal}
				cancellable={false}
				closeable={true}
				size={editorSize}
				eventPreview
			>
				{modalBody}
			</ModalComponent>
		</div>
	);
};

export default SessionPreviewModal;